(() => {
  if (window.theme?.settings?.enablePredictiveSearch === false) return;
  document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
    const input = form.querySelector('[data-predictive-search-input]');
    const results = form.parentElement.querySelector('[data-predictive-search-results]');
    if (!input || !results || !window.theme.settings) return;
    let controller;
    input.addEventListener('input', () => {
      const query = input.value.trim();
      clearTimeout(input.timer);
      if (query.length < 2) { results.innerHTML = ''; return; }
      input.timer = setTimeout(async () => {
        controller?.abort(); controller = new AbortController();
        const params = new URLSearchParams({ q: query, 'resources[type]': 'product,collection,page', 'resources[limit]': '8', section_id: 'predictive-search' });
        try {
          const response = await fetch(`${window.theme.routes.predictiveSearch}?${params}`, { signal: controller.signal });
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          results.innerHTML = doc.querySelector('.predictive-search__content')?.outerHTML || '';
        } catch (error) { if (error.name !== 'AbortError') results.innerHTML = ''; }
      }, 180);
    });
  });
})();
